/**
 * GridPercentSign
 * Render a small percent-sign in DataGridCell
 */
export function GridPercentSign() {
    return <span>%</span>;
}
